<template>
  <div class="wrap wrap-intel">
    <div class="banner">
      <img src="@/assets/images/banner_12.png" class="img-fluid">
      <div class="banner-info">
        <div class="left">
          <h2>溶解仪-4C</h2>
          <p style="line-height: 2;font-size: 16px">主要用于不同单体实现不同的通道等摩尔量的溶解，适用于实验室，以及合成生产的企业使用。</p>
        </div>
        <div class="img_a" style="width:35%"><img src="@/assets/images/r01_1.png" width="100%" class="product"></div>
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container container1">
      <div class="c-title">产品特点</div>
      <el-row :gutter="90" type="flex" align="middle">
        <el-col :span="8">
          <div class="tc"><img src="@/assets/images/r01_1.png" width="240"></div>
        </el-col>
        <el-col :span="16">
          <ul class="lists">
            <li>不同单体实现不同的通道等摩尔量的溶解</li>
            <li>合理的溶解单体以节约不必要的成本浪费，避免出现各类交叉污染</li>
            <li>独立通道防止交叉感染</li>
          </ul>
        </el-col>
      </el-row>
    </section>
    <section class="save">
      <div class="c-title">存储环境条件</div>
      <div class="container container1">
        <ul>
          <li>
            <img src="@/assets/images/save_icon_1.png">
            <p>储存位置的环境温度必须在
              2 ~ 30（℃）范围内 </p>
          </li>
          <li>
            <img src="@/assets/images/save_icon_2.png">
            <p>必须放置于无尘垢、干燥的
              位置 </p>
          </li>
          <li>
            <img src="@/assets/images/save_icon_3.png">
            <p>包装存放在架子或台面</p>
          </li>
          <li>
            <img src="@/assets/images/save_icon_4.png">
            <p>储存位置的相对湿度必须在
              0 ~ 95%范围内，且无结露  </p>
          </li>
          <li>
            <img src="@/assets/images/save_icon_5.png">
            <p>避免储存于含有腐蚀性气、
              液体的环境中 </p>
          </li>
        </ul>
      </div>
    </section>
    <section class="container">
       <div class="dispose">
        <div class="title">标准配置</div>
        <el-row class="text-row">
          <el-col :span="24" class="list-item"><div><span class="circle"></span>溶解仪 1台</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="24" class="list-item"><div><span class="circle"></span>无油真空泵 1套</div></el-col>
        </el-row>
      </div>
   </section>
    <section class="container">
      <div class="c-title">性能参数</div>
      <el-row :gutter="40">
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">电源</td>
              <td>220 ACV, 50 Hz</td>
            </tr>
            <tr>
              <td>功率</td>
              <td>300 W</td>
            </tr>
            <tr>
              <td>外形尺寸</td>
              <td>400 x 600 x 350 mm</td>
            </tr>
            <tr>
              <td>通道数量</td>
              <td>4</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">温度</td>
              <td>25 ± 1 ℃</td>
            </tr>
            <tr>
              <td>湿度</td>
              <td>≤ 30% RH</td>
            </tr>
            <tr>
              <td>打液精度</td>
              <td>5 μL</td>
            </tr>
            <tr>
              <td>打液方式</td>
              <td>自动打液/定时打液</td>
            </tr>
          </table>
        </el-col>
      </el-row>
    </section>
  </div>
</template>
<style scoped>
@import url("../../assets/akta.css");
</style>
<style scoped lang="scss">
  .lists{
    display: unset !important;
    li{
      text-align: left;
    }
  }
  /deep/.right-col{
    padding: 0 !important;
  }
  .center-ele{
  margin-left: 100px;
  text-align: center;
  font-weight: bold;
}
.desc-ch{
  margin-top:-35px;
}
.desc-eh{
  margin-top:-16px;
}
.text-desc-list{
  padding-left: 26px;
}
.list-item{
  position: relative;
  padding-left: 20px !important;
}
.circle{
  display: inline-block;
  background: #014492;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 20px;
  position: absolute;
  left: 0px;
  top:4px;
}
.text-row{
  padding:10px 0;
}
</style>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/R01.vue